const monitoringVelocityObject = {

    zoomEnabled: true,
    panEnabled: true,
    animationEnabled: true,
    rangeSelector: {
      enabled: false,
      selectedRangeButtonIndex: 1,
    //   buttons: [{
    //     label: "Hourly",
    //     range: 1,
    //     rangeType: "hour"
    //   }, {
    //     label: "Daily",
    //     range: 1,
    //     rangeType: "day"
    //   },{
    //     label: "Weekly",
    //     range: 1,
    //     rangeType: "week"
    //   }]
    },
    charts: [{
      axisX: {
        crosshair: {
          enabled: false,
          valueFormatString: "MMM DD, YYYY HH:mm:ss"
        },
        labelFontFamily: "Roboto-Regular",
        labelFontColor: "#444",
        labelFontSize: 12,
        margin: 10,
        tickLength: 15,
        tickColor: "transparent",
        valueFormatString: "YYYY-MM-DD HH:mm:ss",
      },
      axisY: {
        prefix: "",
        includeZero: false,
        gridThickness: 0,
        gridColor: "#e8e8e8",
        labelFontFamily: "Roboto-Regular",
        labelFontColor: "#444",
        labelFontSize: 12,
        lineThickness: 0,
        tickLength: 10,
        tickColor: "transparent",
      },
      toolTip: {
        shared: true,
        contentFormatter: function (e) {
          var content =
            e.entries[0].dataPoint.x.toLocaleString() + "<br/>";
          for (var i = 0; i < e.entries.length; i++) {
            if(e.chart.options.unit == undefined){
              e.chart.options.unit = "";
            }
            content +=
              e.entries[i].dataSeries.name +
              " " +
              "<strong>" +
              e.entries[i].dataPoint.y.toFixed(2) +
              " " +
               e.chart.options.unit +
              "</strong>";
            content += "<br/>";
          }
          return content;
        },
      },
      legend: {
        legendMarkerColor: "none",
        verticalAlign: "top",
        horizontalAlign: "center",
        showInLegend: true,
        legendText: "Numbers",
        fontSize: 19,
        fontColor: "#191919",
        fontWeight: "normal",
        markerMargin: 10,
        fontFamily: "Roboto-Regular",
        cursor: "pointer",
        itemclick: function (e) {
          if (
            typeof e.dataSeries.visible === "undefined" ||
            e.dataSeries.visible
          ) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        },
      },
      data: [],
    }],
    navigator: {
      dynamicUpdate: true,
    //   data: [
    //     {
    //       type: "line",
    //       dataPoints: []
    //     },
    //     {
    //       type: "line",
    //       dataPoints: []
    //     },
    //     {
    //       type: "line",
    //       dataPoints: []
    //     }
    //   ],
    }
  }

  module.exports = monitoringVelocityObject;